// S3/CloudFront serves every page at its trailing-slash URL
// (e.g. /en/tools/url-encoder/) and 301s the no-slash form. Internal links,
// canonicals, hreflang alternates and the sitemap must all point at the final
// 200 URL, so every page path the app emits goes through these helpers.
// Keep in sync with pageUrl() in scripts/prerender-meta.js and
// scripts/generate-sitemap.js.

export const SITE_URL = "https://quto.dev";
// Root homepage URL (served 200 at "/"), used for Organization/WebSite urls.
export const SITE_HOME = `${SITE_URL}/`;

// Append "/" to the path portion of a page URL, leaving any ?query / #hash
// intact. Paths whose last segment looks like a file (has an extension) are
// returned unchanged.
export function withTrailingSlash(url) {
  const match = String(url).match(/^([^?#]*)(.*)$/);
  const pathPart = match[1];
  const suffix = match[2];
  if (pathPart === "" || pathPart.endsWith("/")) return url;
  const lastSegment = pathPart.slice(pathPart.lastIndexOf("/") + 1);
  if (lastSegment.includes(".")) return url;
  return `${pathPart}/${suffix}`;
}

// "/en" + "/tools/url-encoder" -> "/en/tools/url-encoder/"; "" -> "/en/".
export function localizedPath(lang, rest = "") {
  return withTrailingSlash(`/${lang}${rest}`);
}

// Absolute URL for a localized page: "https://quto.dev/en/tools/url-encoder/".
export function pageUrl(lang, rest = "") {
  return `${SITE_URL}${localizedPath(lang, rest)}`;
}
